import { render, staticRenderFns } from "./FourParallels.vue?vue&type=template&id=2256ae95&scoped=true&"
import script from "./FourParallels.vue?vue&type=script&lang=js&"
export * from "./FourParallels.vue?vue&type=script&lang=js&"
import style0 from "./FourParallels.vue?vue&type=style&index=0&id=2256ae95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256ae95",
  null
  
)

export default component.exports